export default {
  //授权型号
  getDeviceCustom: {
    method: 'get',
    url: 'device-custom/list',
    permission: {
      name: "获取授权型号列表",
      page: "deviceAuthModel",
    }
  },
  importDevice: {
    method: 'post',
    url: 'device-custom/import',
    permission: {
      name: "导入设备",
      page: "deviceAuthModel",
    }
  },
  reviseDevice: {
    method: 'post',
    url: 'device-custom/mod',
    permission: {
      name: "修改授权型号",
      page: "deviceAuthModel",
    }
  },
  deleteDevice: {
    method: 'post',
    url: 'device-custom/del',
    permission: {
      name: "删除授权型号",
      page: "deviceAuthModel",
    }
  },
  //测试授权
  getAuthTest: {
    method: 'get',
    url: 'auth-test/list',
    permission: {
      name: "获取测试授权列表",
      page: "deviceAuthTest",
    }
  },
  importTest: {
    method: 'post',
    url: 'auth-test/import',
    permission: {
      name: "导入测试授权",
      page: "deviceAuthTest",
    }
  },
  reviseTest: {
    method: 'post',
    url: 'auth-test/mod',
    permission: {
      name: "修改测试授权",
      page: "deviceAuthTest",
    }
  },
  deleteTest: {
    method: 'post',
    url: 'auth-test/del',
    permission: {
      name: "删除测试授权",
      page: "deviceAuthTest",
    }
  },
  downloadTestKey: {
    method: 'post',
    url: 'auth-test/key',
    permission: {
      name: "下载Key文件",
      page: "deviceAuthTest",
    }
  },
  //正式授权
  getAuthFormal: {
    method: 'get',
    url: 'auth-prod/list',
    permission: {
      name: "获取正式授权列表",
      page: "deviceAuthFormal",
    }
  },
  importFormal: {
    method: 'post',
    url: 'auth-prod/import',
    permission: {
      name: "导入正式授权",
      page: "deviceAuthFormal",
    }
  },
  reviseFormal: {
    method: 'post',
    url: 'auth-prod/mod',
    permission: {
      name: "修改正式授权",
      page: "deviceAuthFormal",
    }
  },
  deleteFormal: {
    method: 'post',
    url: 'auth-prod/del',
    permission: {
      name: "删除正式授权",
      page: "deviceAuthFormal",
    }
  },
  downloadFormalKey: {
    method: 'post',
    url: 'auth-prod/key',
    permission: {
      name: "下载Key文件",
      page: "deviceAuthFormal",
    }
  },
  //设备列表
  getDeviceList: {
    method: 'get',
    url: 'device/list',
    permission: {
      name: "获取设备列表",
      page: "deviceAuthList",
    }
  },
  //授权日志
  getAuthLog: {
    method: 'get',
    url: 'device-auth-log/list',
    permission: {
      name: "获取设备授权日志",
      page: "deviceAuthLog",
    }
  },
}
